import React, { useState } from "react";
import UnlockRemixAiPrompt from "./UnlockRemixAiPrompt";

const HORIZONTAL_PADDING = "15px";
const CAMPAIGN_INSIGHT_SECTION_PADDING = "20px";
const RECOMMENDATION_PREVIEW_MAX_LENGTH = 110;
const CALLOUT_PREVIEW_MAX_LENGTH = RECOMMENDATION_PREVIEW_MAX_LENGTH * 3;
const OVERVIEW_TEXT_STYLE = { lineHeight: 1.85 };
const REMIX_GRADIENT_BORDER_STYLE = {
  background: `
    linear-gradient(white, white) padding-box,
    linear-gradient(90deg, #6B8CFF 0%, #003FFF 100%) border-box
  `,
  border: "1px solid transparent",
};

const RemixSparkleIcon = () => (
  <svg
    width="13"
    height="14"
    viewBox="0 0 13 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    style={{ flexShrink: 0 }}
  >
    <path
      d="M10.5086 7.86766L8.97152 7.42808C8.27936 7.23279 7.64886 6.86299 7.14034 6.35408C6.63183 5.84516 6.26232 5.21416 6.06718 4.52145L5.62795 2.9832C5.60586 2.92939 5.56829 2.88336 5.52 2.85096C5.47171 2.81857 5.41488 2.80127 5.35675 2.80127C5.29861 2.80127 5.24179 2.81857 5.1935 2.85096C5.14521 2.88336 5.10763 2.92939 5.08554 2.9832L4.64631 4.52145C4.45117 5.21416 4.08166 5.84516 3.57315 6.35408C3.06464 6.86299 2.43413 7.23279 1.74197 7.42808L0.204942 7.86766C0.145925 7.88443 0.0939831 7.92 0.0569971 7.96898C0.0200111 8.01797 0 8.07769 0 8.13908C0 8.20048 0.0200111 8.2602 0.0569971 8.30918C0.0939831 8.35817 0.145925 8.39374 0.204942 8.4105L1.74197 8.85008C2.43413 9.04538 3.06464 9.41517 3.57315 9.92409C4.08166 10.433 4.45117 11.064 4.64631 11.7567L5.08554 13.295C5.10229 13.354 5.13783 13.406 5.18678 13.443C5.23572 13.48 5.2954 13.5001 5.35675 13.5001C5.41809 13.5001 5.47777 13.48 5.52671 13.443C5.57566 13.406 5.6112 13.354 5.62795 13.295L6.06718 11.7567C6.26232 11.064 6.63183 10.433 7.14034 9.92409C7.64886 9.41517 8.27936 9.04538 8.97152 8.85008L10.5086 8.4105C10.5676 8.39374 10.6195 8.35817 10.6565 8.30918C10.6935 8.2602 10.7135 8.20048 10.7135 8.13908C10.7135 8.07769 10.6935 8.01797 10.6565 7.96898C10.6195 7.92 10.5676 7.88443 10.5086 7.86766Z"
      fill="#003FFF"
    />
    <path
      d="M12.9087 2.75173L12.2256 2.55636C11.918 2.46956 11.6378 2.30521 11.4118 2.07903C11.1858 1.85284 11.0215 1.5724 10.9348 1.26452L10.7396 0.58086C10.7298 0.556941 10.7131 0.536483 10.6916 0.522085C10.6702 0.507687 10.6449 0.5 10.6191 0.5C10.5932 0.5 10.568 0.507687 10.5465 0.522085C10.525 0.536483 10.5083 0.556941 10.4985 0.58086L10.3033 1.26452C10.2166 1.5724 10.0524 1.85284 9.82635 2.07903C9.60034 2.30521 9.32012 2.46956 9.01249 2.55636L8.32937 2.75173C8.30314 2.75918 8.28005 2.77499 8.26361 2.79676C8.24718 2.81853 8.23828 2.84507 8.23828 2.87236C8.23828 2.89965 8.24718 2.92619 8.26361 2.94796C8.28005 2.96973 8.30314 2.98554 8.32937 2.99299L9.01249 3.18836C9.32012 3.27516 9.60034 3.43951 9.82635 3.6657C10.0524 3.89188 10.2166 4.17233 10.3033 4.4802L10.4985 5.16386C10.506 5.19011 10.5218 5.21322 10.5435 5.22967C10.5653 5.24612 10.5918 5.25502 10.6191 5.25502C10.6463 5.25502 10.6728 5.24612 10.6946 5.22967C10.7164 5.21322 10.7321 5.19011 10.7396 5.16386L10.9348 4.4802C11.0215 4.17233 11.1858 3.89188 11.4118 3.6657C11.6378 3.43951 11.918 3.27516 12.2256 3.18836L12.9087 2.99299C12.935 2.98554 12.9581 2.96973 12.9745 2.94796C12.9909 2.92619 12.9998 2.89965 12.9998 2.87236C12.9998 2.84507 12.9909 2.81853 12.9745 2.79676C12.9581 2.77499 12.935 2.75918 12.9087 2.75173Z"
      fill="#003FFF"
    />
  </svg>
);

const truncateAtWord = (text, maxLength) => {
  if (!text || text.length <= maxLength) {
    return text;
  }

  const slice = text.slice(0, maxLength);
  const lastSpace = slice.lastIndexOf(" ");

  if (lastSpace > maxLength * 0.6) {
    return `${slice.slice(0, lastSpace).trimEnd()}…`;
  }

  return `${slice.trimEnd()}…`;
};

const buildPlaybookUrl = (websiteId, recommendation) => {
  const playbookId = recommendation.playbook_id;
  const remixPrompt = recommendation.title?.trim();
  if (!websiteId || !playbookId || !remixPrompt) {
    return null;
  }

  const params = new URLSearchParams();
  params.set("remix_prompt", remixPrompt);

  return `/websites/${websiteId}/playbooks/${playbookId}?${params.toString()}`;
};

const ExpandToggleButton = ({ onClick }) => (
  <button
    type="button"
    className="inline bg-transparent border-0 p-0 text-blue-600 cursor-pointer hover:underline"
    onClick={onClick}
  >
    Read More
  </button>
);

const ExpandableText = ({
  text,
  maxLength,
  isPlaceholder = false,
  useLightText = false,
  isOverview = false,
  suffix = null,
}) => {
  const [expanded, setExpanded] = useState(false);
  const isTruncatable = text && text.length > maxLength;
  const displayText =
    expanded || !isTruncatable ? text : truncateAtWord(text, maxLength);

  return (
    <p
      className={`text-xl mb-0 ${isOverview ? "" : "leading-relaxed"} ${
        useLightText || isPlaceholder ? "light" : ""
      }`}
      style={isOverview ? OVERVIEW_TEXT_STYLE : undefined}
    >
      {displayText}
      {isTruncatable && !expanded && (
        <>
          {" "}
          <ExpandToggleButton onClick={() => setExpanded(true)} />
        </>
      )}
      {suffix}
    </p>
  );
};

const RecommendationCard = ({
  recommendation,
  align,
  isPlaceholder,
  websiteId,
  playbooksById,
}) => {
  const playbook =
    playbooksById?.[recommendation.playbook_id] ||
    playbooksById?.[String(recommendation.playbook_id)];
  const playbookUrl = buildPlaybookUrl(websiteId, recommendation);
  const headerTitle = playbook?.name || recommendation.title;

  return (
    <div
      className={`col-md-6 col-sm-12 ${
        align === "left" ? "no-padding-left" : "no-padding-right"
      }`}
      style={{ marginBottom: "12px" }}
    >
      <div
        className="rounded-xl overflow-hidden h-full bg-white"
        style={REMIX_GRADIENT_BORDER_STYLE}
      >
        <div className="flex items-center gap-2 px-5 py-4 border-b border-slate-100 min-w-0">
          <RemixSparkleIcon />
          <span
            className="text-[14px] font-medium text-[#003FFF] ellipsis min-w-0 flex-1"
            title={headerTitle}
          >
            {headerTitle}
          </span>
        </div>
        <div className="px-5 py-5">
          <ExpandableText
            text={recommendation.title}
            maxLength={RECOMMENDATION_PREVIEW_MAX_LENGTH}
            isPlaceholder={isPlaceholder}
            useLightText
          />
          {isPlaceholder && recommendation.learn_url && (
            <a
              href={recommendation.learn_url}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block mt-5 text-xl"
            >
              Learn more →
            </a>
          )}
          {!isPlaceholder && playbookUrl && (
            <a
              href={playbookUrl}
              className="inline-flex items-center mt-5 px-5 py-2.5 rounded-full text-xl font-semibold !text-white hover:!text-white focus:!text-white visited:!text-white border-none no-underline transition-opacity hover:opacity-90"
              style={{
                background: "linear-gradient(135deg, #4f6fff 0%, #003FFF 100%)",
                color: "#fff",
              }}
            >
              Use Playbook →
            </a>
          )}
        </div>
      </div>
    </div>
  );
};

const WebsiteInsightRecommendations = (props) => {
  const {
    recommendations,
    websiteId,
    website,
    remixAiGated = false,
    noCampaigns = false,
    playbooksById = {},
    embedded = false,
    overviewTitle = "Overview",
  } = props;

  if (!recommendations) {
    return null;
  }

  const items = (recommendations.recommendations || []).slice(0, 2);
  const showPlaceholder = recommendations.recommendations_are_placeholder;
  const showUnlockPrompt =
    remixAiGated && recommendations.callout_is_placeholder;
  const horizontalPadding = embedded ? "0" : HORIZONTAL_PADDING;

  return (
    <div
      className="WebsiteInsightRecommendations"
      style={{
        borderTop: embedded ? "none" : "1px solid rgb(233, 235, 241)",
        padding: embedded
          ? `12px ${horizontalPadding} ${CAMPAIGN_INSIGHT_SECTION_PADDING}`
          : `12px ${horizontalPadding} 16px`,
      }}
    >
      <div className="vertical-space">
        <h4 className="bold mb-3">{overviewTitle}</h4>
        <div
          className={`rounded-xl px-5 py-5 border-solid border-[1px] ${
            recommendations.callout_is_placeholder
              ? "border-dashed border-slate-300 bg-slate-50"
              : "border-slate-200 bg-white"
          }`}
        >
          {showUnlockPrompt ? (
            <UnlockRemixAiPrompt website={website} style={OVERVIEW_TEXT_STYLE} />
          ) : noCampaigns && recommendations.callout_is_placeholder ? (
            <p className="text-xl mb-0 light" style={OVERVIEW_TEXT_STYLE}>
              No AI insights this week — no campaigns had enough traffic to analyze. Launch a campaign and drive traffic to unlock AI recommendations.
            </p>
          ) : (
            <ExpandableText
              text={recommendations.callout}
              maxLength={CALLOUT_PREVIEW_MAX_LENGTH}
              isPlaceholder={recommendations.callout_is_placeholder}
              isOverview
            />
          )}
        </div>
      </div>

      {!(remixAiGated && showPlaceholder) && (
        <div className="vertical-space" style={{ marginTop: "20px" }}>
          <h4 className="bold mb-3">Recommendations</h4>
          <div
            className="row hard-center"
            style={{ marginLeft: 0, marginRight: 0 }}
          >
            {items.map((recommendation, index) => (
              <RecommendationCard
                key={`website-recommendation-${index}`}
                recommendation={recommendation}
                align={index % 2 === 0 ? "left" : "right"}
                isPlaceholder={showPlaceholder || recommendation.placeholder}
                websiteId={websiteId}
                playbooksById={playbooksById}
              />
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default WebsiteInsightRecommendations;
